import LogRocket from "logrocket";

const logPipedreamEvent = (obj) => {
  const { category, action, label } = obj;
  try {
    // These properties are most salient for Google Analytics
    // See how these map to GA properties here:
    // https://segment.com/docs/connections/destinations/catalog/google-analytics/#track
    window.analytics.track(action, {
      category,
      hostname: window.location.hostname,
      label,
    });
  } catch (err) {
    // Don't log event if any error is thrown
  }

  try {
    // Sentry has no Logrocket integration, so we additionally want to send
    // custom events there so we can search for events in Logrocket sessions
    // See https://docs.logrocket.com/reference#track
    LogRocket.track(`${category} - ${action}`);
  } catch (err) {
    // Don't log event if any error is thrown
  }
};

export { logPipedreamEvent };
